<gc-text [variant]="'bodyBold'">{{ labelString() }}:</gc-text>
<gc-text [variant]="'body'">{{ valueString() }}</gc-text>
